import classes from "../Styling/SharedStyling.module.css"

import React, { useEffect, useState } from 'react';
import mockup1 from '../Images/MovingTasksItems/Tasks_1.png';
import mockup2 from '../Images/MovingTasksItems/Items_1.png';
import mockup3 from '../Images/MovingTasksItems/Tasks_Detail.png';
import mockup4 from '../Images/MovingTasksItems/Items_Detailed.png';
import mockup5 from '../Images/MovingTasksItems/Settings_1.png';
import mockup6 from '../Images/MovingTasksItems/Items_Searching.png';
import mockup7 from '../Images/MovingTasksItems/DarkMode.png';

export default function MovingHelperPage()
{
  const thresholdWidth = 1000; // MUST BE CHANGED IN TANDEM WITH CSS

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }
  
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function leadingImageLayout(text: String, imgSource: string, dark: boolean = false)
  {
    return (
      <div className={classes.container}>
        <div className={classes.halfContainerMH}>
          <img alt="iPhone Mockup Showing Feature" className={classes.mockupLeft} src={imgSource}></img>
        </div>
        <h2 className={dark ? classes.mockupTextRightDarkMH : classes.mockupTextRightMH}>{text}</h2>
      </div>
    );
  }

  function trailingImageLayout(text: String, imgSource: string)
  {
    return (
      windowDimensions.width > thresholdWidth ?
        <div className={classes.container}>
          <h2 className={classes.mockupTextLeftMH}>{text}</h2>
          <div className={classes.halfContainerMH}>
            <img alt="iPhone Mockup Showing Feature" className={classes.mockupRight} src={imgSource}></img>
          </div>
        </div>
        : 
        leadingImageLayout(text, imgSource)
    );
  }

  return (
    <div>
      <div className={classes.appDetailsWrapper}>
        <h1 className={classes.appName}>Moving - Tasks & Items</h1>
        <a className={classes.appLinkMH} target={"_blank"} href="https://apps.apple.com/ee/app/moving-tasks-items/id6472617379">learn more</a>        
      </div>

      {leadingImageLayout("Keep Track Of Tasks And Deadlines At A Glance...", mockup1)}
      {trailingImageLayout("Add Items For Your Move...", mockup2)}
      {leadingImageLayout("Add Status Updates, Subtasks, and Link To Items...", mockup3)}
      {trailingImageLayout("Add Tags, Dimensions, Contents, and Link To Tasks...", mockup4)}
      {leadingImageLayout("Keep Track Of Multiple Moves Simultaneously...", mockup5)}
      {trailingImageLayout("Search To Quickly Find Tasks And Items...", mockup6)}
      {leadingImageLayout("Also Available In Dark Mode.", mockup7, true)}
    </div>
    );
}